/*
 *	Env bridge for the SDK: it resolves its Cognito pool and endpoints when its
 *	module evaluates, so this must load before anything that imports the SDK.
 */
// Named binding: with no imports above, a statement opening with "(" glues onto
// the injected process polyfill.
const globalScope = globalThis as unknown as { SIGNALOID_ENV_VARS?: Record<string, string | undefined> };

globalScope.SIGNALOID_ENV_VARS = {
	USER_POOL_ID: import.meta.env.VITE_COGNITO_USER_POOL_ID,
	USER_POOL_WEB_CLIENT_ID: import.meta.env.VITE_COGNITO_CLIENT_APP_ID,
	API_ENDPOINT: import.meta.env.VITE_SIGNALOID_API_URL,
	SIGNALOID_BASE_ENV: import.meta.env.MODE === "production" ? "production" : "staging",
};
